import React from 'react';
import './Taby.css';

const Taby = ({code, title, show, setShow}) => {
  const handleClick = () => {
    setShow(code);
  }
  const style = `taby ${code === show ? 'active' : ''}`
  return (
    <div className={style} onClick={handleClick}>{title}</div>
  );
};

export default Taby;